import { useEffect } from "react";

/**
 * Loads the UnicornStudio embed runtime once and aggressively hides its branding.
 * Ported as-is (behaviour-wise) from the reference `hero-ascii` component,
 * adapted to plain React/JS. Any element with `data-us-project` is initialised.
 */
export const UNICORN_PROJECT_ID = "whwOGlfJ5Rz2rHaEUgHl";

export const useUnicornStudio = () => {
  useEffect(() => {
    const embedScript = document.createElement("script");
    embedScript.type = "text/javascript";
    embedScript.textContent = `
      !function(){
        if(!window.UnicornStudio){
          window.UnicornStudio={isInitialized:!1};
          var i=document.createElement("script");
          i.src="https://cdn.jsdelivr.net/gh/hiunicornstudio/unicornstudio.js@v1.4.33/dist/unicornStudio.umd.js";
          i.onload=function(){
            window.UnicornStudio.isInitialized||(UnicornStudio.init(),window.UnicornStudio.isInitialized=!0)
          };
          (document.head || document.body).appendChild(i)
        } else if (window.UnicornStudio.init) {
          try { window.UnicornStudio.init(); } catch (e) {}
        }
      }();
    `;
    document.head.appendChild(embedScript);

    const hideBranding = () => {
      document.querySelectorAll("[data-us-project]").forEach((projectDiv) => {
        projectDiv.querySelectorAll("*").forEach((el) => {
          if (el.tagName === "CANVAS") return;
          const text = (el.textContent || "").toLowerCase();
          if (text.includes("made with") || text.includes("unicorn")) el.remove();
        });
      });
    };
    hideBranding();
    const interval = setInterval(hideBranding, 100);
    const t1 = setTimeout(hideBranding, 1000);
    const t2 = setTimeout(hideBranding, 3000);
    const t3 = setTimeout(hideBranding, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      if (embedScript.parentNode) embedScript.parentNode.removeChild(embedScript);
    };
  }, []);
};
